import React from 'react'

export const PrinterIcon = ({className = "w-6 h-6 fill-app-matte-black"}) => {
   return (
      <svg className={className} viewBox="0 0 24 24">
         <path d="M19 7h-1V2H6v5H5c-1.65 0-3 1.35-3 3v7c0 1.1.9 2 2 2h2v3h12v-3h2c1.1 0 2-.9 2-2v-7c0-1.65-1.35-3-3-3M8 4h8v3H8zm8 16H8v-4h8zm4-3h-2v-3H6v3H4v-7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1z"></path>
         <path d="M14 11h4v1h-4z"></path>
      </svg>
   )
}